import { render, staticRenderFns } from "./ArticleDetailView.vue?vue&type=template&id=0b7b4555&scoped=true&"
import script from "./ArticleDetailView.vue?vue&type=script&lang=js&"
export * from "./ArticleDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7b4555",
  null
  
)

export default component.exports